import { useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../lib/domain';
import { ApiError } from '../lib/api';

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await authApi.resetPassword(token, password);
      navigate('/login');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Zurücksetzen fehlgeschlagen.');
    }
  }

  return (
    <div className="stack">
      <h1>Neues Passwort setzen</h1>
      <form className="stack card" onSubmit={onSubmit}>
        <div className="field">
          <label htmlFor="password">Neues Passwort (mind. 6 Zeichen)</label>
          <input id="password" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p className="error-text" role="alert">{error}</p>}
        <button className="primary" type="submit">
          Passwort setzen
        </button>
      </form>
    </div>
  );
}
